export { NewDataCall } from "./pages/newLeads";
export { default as ViewNewDataCall } from "./pages/viewNewLead";
export { default as NewDataCallDetails } from "./pages/CallDetails";

